<div
  *ngIf="!scenariosEnabledForAtLeastOneSite; else scenariosList"
  class="error-info"
  translate="parameters/quick_replies/quick_replies_disabled_all_sites_text"></div>

<ng-template #scenariosList>
  <app-filters-side-panel
    [siteFilterCb]="keepSitesWithQuickRepliesEnabled"
    [allowSiteGroups]="true"
    selectionMode="radio-button-mode"
    [capabilities]="[CapabilityIdEnum.Automation, CapabilityIdEnum.Marketing]">
    <mat-card>
      <mat-card-content>
        <app-search-bar
          [primaryButtonAction]="primaryButtonAction"
          [searchKey]="'parameters/quick_replies/search'"
          [primaryButtonKey]="'parameters/quick_replies/add_scenario'"></app-search-bar>
        <app-table [config]="config" [filters]="filters"></app-table>

        <div *ngIf="metricsAndReportsState" class="alc-padding-top-32 alc-margin-16">
          <a [href]="metricsAndReportsState" translate="parameters/quick_replies/metrics_link"></a>
        </div>
      </mat-card-content>
    </mat-card>
  </app-filters-side-panel>
</ng-template>
